export default {
  INVALID_PASSWORD: 'INVALID_PASSWORD',
  FIFTH_ATTEMPT: 'attempt_5th_invalid_password',
  TENTH_ATTEMPT: 'attempt_10th_invalid_password',
  BLOCKED: 'blocked',
  TOO_MANY_REQUESTS: 'Too Many Requests',
  TOO_MANY_CHANGE_REQUESTS: 'too_many_failed_password_change_attempts',
  NOT_ALLOWED_WORKSPACE: 'workspace_not_allowed',
  LOGIN_OPTION_NOT_ALLOWED: 'login_option_not_allowed'
};
